<template>
  <div
    v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
  >
    <el-row>
      <el-col :span="24">
        <el-table
          :data="tableData"
          stripe
          border
          style="width: 100%; margin-top: 15px"
        >
          <el-table-column
            align="center"
            type="index"
            width="50"
          ></el-table-column>
          <el-table-column
            prop="courseName"
            label="课程名称"
            align="center"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="nodeName"
            label="所属维度"
            align="center"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="courseType"
            label="课程类型"
            align="center"
            width="150"
          >
            <template slot-scope="scope">
                <span v-if="scope.row.courseType == 1">国家课程</span>
                <span v-if="scope.row.courseType == 2">校本课程</span>
                <span v-if="scope.row.courseType == 3">机构课程</span>
            </template>
          </el-table-column>
          <el-table-column prop="leafName" label="适用年级" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                v-for="list in scope.row.schoolCourseGradeList"
                :key="list.gradeId"
                >{{ list.gradeName }}</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="leafName"
            label="课程状态"
            align="center"
            width="120"
          >
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.isOpen"
                @change="schoolCourseisOpen(scope.row)"
                :active-value="1"
                :inactive-value="2"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column
            prop="leafName"
            label="操作"
            align="center"
            width="280"
          >
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="bianji(scope.row,scope.$index)"
                >编辑</el-button
              >
              <!-- <el-button
                type="text"
                size="small"
                @click="schoolCoursedelSchoolCourse(scope.row.courseId)"
                >删除</el-button
              >
              <el-button
                type="text"
                size="small"
                v-if="activeName==2"
                @click="xueshen(scope.row.courseId)"
                >学生名单</el-button
              > -->
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      
    </el-row>
    <div class="btns df jc-e">
      <div class="add_calss df ai-c" v-if="courseOfferingStatus">
        如需其他课程，您可前往<el-link type="danger" :underline="false" @click="goClass">课程开展</el-link>添加
      </div>
        <el-button size="mini" plain type="primary" @click="handlePreOrNext(0)">上一步:{{progressStatusList[0]&&progressStatusList[0].progressItemName}}</el-button>
        <el-button size="mini" plain type="primary" @click="handlePreOrNext(2,'saveCourse')">下一步:{{progressStatusList[2]&&progressStatusList[2].progressItemName}}</el-button>
      </div>
    <el-pagination
      :current-page.sync="pageNum"
      style="margin-top: 15px; float: right"
      @prev-click="gai"
      @next-click="gai"
      @current-change="gai"
      :page-size="10"
      :hide-on-single-page="true"
      background
      layout="total,prev, pager, next"
      :total="totalCount"
    ></el-pagination>
    <el-dialog :modal-append-to-body="false" :title="title" :visible.sync="dialogVisible" width="50%">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="课程分类" prop="courseType">
          <template v-for="list in butt">
            <el-button
            :type="ruleForm.courseType == list.id ? 'primary' : ''"
            size="mini"
            
            :key="list.id"
            @click="ruleForm.courseType = list.id"
            v-if="ruleForm.courseType == list.id"
            >{{ list.name }}</el-button
          >
          </template>
        </el-form-item>
        <el-form-item label="课程名称" prop="courseName">
          <el-input v-model="ruleForm.courseName" style="width: 250px"></el-input>
        </el-form-item>
        <el-form-item
          label="所属学科"
          prop="subjecid"
          class="buttid"
          v-if="ruleForm.courseType == 1"
        >
          <!-- @click="
              ruleForm.subjecid = list.id;
              subjectName = list.name;
            " -->
          <el-button
            :type="ruleForm.subjectId == list.id ? 'primary' : ''"
            size="mini"
            v-for="list in subjec"
            :key="list.id"
            @click="subjectClick(list)"
            >{{ list.name }}</el-button
          >
        </el-form-item>
        <el-form-item label="负责老师" v-if="ruleForm.courseType == 2">
          <el-input
            v-model="ruleForm.teachers"
            style="width: 250px"
            disabled
          ></el-input>
          <el-button type="primary" size="mini" @click="dialogVisible1 = true"
            >选择</el-button
          >
          <el-button size="mini">清空</el-button>
        </el-form-item>
        <el-form-item label="适用年级" prop="graid">
         <el-checkbox-group v-model="ruleForm.graid" >
            <span
              style="margin-right: 20px"
              v-for="list in gradegr"
              :key="list.gradeId"
            >
              <el-checkbox
                v-if="subGrades.indexOf(list.gradeId) != -1"
                :label="list.gradeId"
                >{{ list.name }}</el-checkbox
              >
            </span>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="所属维度" style="line-height: 20px" prop="nodeId">
          <el-radio-group v-model="ruleForm.nodeId" @change="checkboxChange">
            <el-radio
              :label="list.id"
              v-for="list in moderole"
              :key="list.id"
              >{{ list.nodeName }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item label="课程开启">
          <el-switch v-model="ruleForm.isOpen" :active-value="1"
                :inactive-value="2"></el-switch>
        </el-form-item>
        <el-form-item style="text-align: right">
          <el-button type="primary" @click="submitForm('ruleForm')" size="small"
            >确定</el-button
          >
          <el-button @click="dialogVisible = false" size="small"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :modal-append-to-body="false" title="选择负责老师" :visible.sync="dialogVisible1" width="50%">
      <el-form label-width="40px">
        <el-form-item label="科室">
          <div style="line-height: 25px">
            <el-select v-model="value" placeholder="请选择科室" clearable>
              <el-option
                v-for="item in department"
                :key="item.value"
                :label="item.departmentName"
                :value="item.departmentId"
              >
              </el-option>
            </el-select>
            <el-input
              style="width: 180px"
              placeholder="请输入老师姓名"
              v-model="depainput"
              @keyup.enter.native="teacherlist"
              class="input-with-select"
            >
              <el-button
                slot="append"
                size="small"
                icon="el-icon-search"
                @click="teacherlist"
              ></el-button>
            </el-input>
          </div>
        </el-form-item>
      </el-form>
      <div style="margin-top: -20px; margin-bottom: 10px">
        共选择{{ tealists.length }}位老师
      </div>
      <el-row style="line-height: 30px" class="huise" v-if="tealist.length > 0">
        <el-checkbox-group v-model="tealists">
          <el-col :span="4" v-for="list in tealist" :key="list.id">
            <el-checkbox :label="list.id">{{ list.name }}</el-checkbox>
          </el-col>
        </el-checkbox-group>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false" size="small"
          >取 消</el-button
        >
        <el-button type="primary" @click="que" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  subjectList,
  gradegradelist,
  nodesgetListByLevel,
  schoolgetdepartmentlist,
  getMyappList,
  teacherLists,
  schoolCoursesaveSchoolCourse,
  schoolCoursequerySchoolCourse,
  schoolCoursedelSchoolCourse,
  schoolCourseisOpen,
  saveCourse,
  schoolClassSatution,
  usercenterinfo,
  getSchoolConfigStep
} from "@/api/home";
import resetMessage from '@/assets/js/resetMessage';
export default {
  data() {
    return {
      loading: false,
      activeName: "1",
      input: "",
      tableData: [],
      input1: "",
      tableData1: [],
      dialogVisible: false,
      dialogVisible1: false,
      moderole: [],
      title: "",
      subjec: [],
      gradegr: [],
      schoolId: "",
      butt: [
        { name: "国家课程", id: 1 },
        { name: "校本课程", id: 2 },
      ],
      ruleForm: {
        course: 1,
        name: "",
        subjecid: "",
        graid: [],
        role: "",
        delivery: true,
        teachers: "",
      },
      rules: {
        courseType: [
          { required: true, message: "请选择课程类型", trigger: "change" },
        ],
        subjectId: [
          { required: true, message: "请选择所属学科", trigger: "change" },
        ],
        graid: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个年级",
            trigger: "change",
          },
        ],
        name: [{ required: true, message: "请输入课程名称", trigger: "blur" }],
        nodeId:[{ required: true, message: "请选择维度", trigger: "blur" }]

      },
      department: [],
      value: "",
      depainput: "",
      tealist: [],
      tealists: [],
      subjectName: "",
      pageNum: 1,
      totalCount: 0,
      courseId: "",
      subGrades: "",
      editIndex:'',//编辑的对象的下表
      courseOfferingStatus:false,//课程配置状态
      myappList:[],//应用列表
      progressStatusList:[],
    };
  },
  watch: {
    tealists() {
      console.log(this.tealists);
    },
    activeName() {
      this.pageNum = 1;
      this.schoolCoursequerySchoolCourse();
    },
  },
  methods: {
    //获取配置进度
    async getConfigProgress(){
      //获取学校配置进度
      let {data:res} = await getSchoolConfigStep()
      let progressArr = res.data.cardPrintItemList
      this.progressStatusList =  progressArr
      progressArr.forEach(item => {
        switch (item.progressItemCode) {
          case 'create_school_course':
             this.courseOfferingStatus = item.progressItemStatus==0?false:true
            break;
          default:
            break;
        }
      })
    },
    sousuo() {
      this.pageNum = 1;
      this.schoolCoursequerySchoolCourse();
    },
    dian(s) {
      console.log(s);
    },
    // 学科点击事件
    subjectClick(item) {
      this.ruleForm.subjectId = item.id;
      this.subjectName = item.name
      this.subGrades = item.grades
      this.ruleForm.graid = []
    },
    subjectlist() {
      let that = this;
      subjectList()
        .then((res) => {
          that.subjec = res.data.data;
          that.ruleForm.subjecid = res.data.data[0].id;
          that.subjectName = res.data.data[0].name;
          that.subGrades = res.data.data[0].grades;
        })
        .catch(() => {});
    },
    nodesgetListByLevel() {
      let that = this;
      let params = {
        nodeLevel: 1,
      };
      nodesgetListByLevel(params)
        .then((res) => {
          that.moderole = res.data.data;
        })
        .catch(() => {});
    },
    gradegradelist() {
      let that = this;
      let params = {
        schoolId: this.schoolId,
      };
      gradegradelist(params)
        .then((res) => {
          that.gradegr = res.data.data;
          that.ruleForm.graid = [];
        })
        .catch(() => {});
    },
    tian() {
      this.dialogVisible = true;
      this.title = "添加课程";
      this.tealists = [];
      this.ruleForm.name = "";
      this.courseId = "";
      if (this.$refs["ruleForm"] !== undefined) {
        this.resetForm("ruleForm");
      }
    },
    submitForm(formName) {
      console.log('ruleForm:',this.ruleForm);
      this.$refs[formName].validate((valid) => {
        console.log('valid:',valid);
        if (valid) {
          //修改所属年级
          let arr = []
          this.gradegr.forEach(item=>{
            item.gradeName = item.name
            if (this.ruleForm.graid.findIndex(it=>it==item.gradeId)!=-1) {
              arr.push(item)
            }
          })
          this.ruleForm.schoolCourseGradeList = arr
          //所属维度 nodeName
          let obj = this.moderole.find(item=>item.id==this.ruleForm.nodeId)
          console.log('obj:',obj);
          if (!obj) {  //解决 课程开始维度 id name脏数据
            return this.$message({
              type:"info",
              message:'请选择维度！'
            })
          }
          this.ruleForm.nodeName = obj.nodeName
          this.$set(this.tableData,this.editIndex,this.ruleForm)
          this.dialogVisible = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    schoolgetdepartmentlist() {
      let that = this;
      let params = {
        schoolId: this.schoolId,
      };
      schoolgetdepartmentlist(params)
        .then((res) => {
          that.department = res.data.data;
        })
        .catch(() => {});
    },
    teacherlist() {
      let that = this;
      let params = {
        schoolId: this.schoolId,
        departmentId: this.value,
        name: this.depainput,
        curPage: 1,
        pageSize: 1000,
      };
      teacherLists(params)
        .then((res) => {
          that.tealist = res.data.data.dataList;
        })
        .catch(() => {});
    },
    que() {
      for (var i = 0; i < this.tealist.length; i++) {
        for (var s = 0; s < this.tealists.length; s++) {
          if (this.tealist[i].id == this.tealists[s]) {
            this.ruleForm.teachers =
              (this.ruleForm.teachers?this.ruleForm.teachers:'') + this.tealist[i].name + ",";
          }
        }
      }
      this.ruleForm.teacherIdList = this.tealists
      this.dialogVisible1 = false;
    },
    schoolCoursequerySchoolCourse() {
      let that = this;
      that.loading = true;
      let params = {
        courseType: this.activeName,
        courseName: this.input,
        pageNum: this.pageNum,
        pageSize: 10,
      };
      schoolClassSatution()
        .then((res) => {
          that.tableData = res.data.data
          that.loading = false;
          // that.totalCount = res.data.data.totalCount;
        })
        .catch(() => {
          that.loading = false;
        });
    },
    gai(s) {
      this.pageNum = s;
      this.schoolCoursequerySchoolCourse();
    },
    bianji(s,index) {
      this.editIndex = index
      this.ruleForm = JSON.parse(JSON.stringify(s))
      // this.ruleForm.isOpen=this.ruleForm.isOpen==1?true:false
      let lisid = [];
      for (var i = 0; i < s.schoolCourseGradeList.length; i++) {
        lisid.push(s.schoolCourseGradeList[i].gradeId);
      }
      this.$set(this.ruleForm,'graid',lisid);
      this.dialogVisible = true;
      
    },
    schoolCoursedelSchoolCourse(s) {
      let that = this;
      let params = {
        courseId: s,
      };
      this.$confirm("此操作将删除该课程, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.loading = true;
          schoolCoursedelSchoolCourse(params)
            .then((res) => {
              that.schoolCoursequerySchoolCourse();
            })
            .catch(() => {
              that.loading = false;
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    xueshen(s){
      this.$router.push({
        path: "/course_list",
        query: {
            id: s
          }
      });
    },
    schoolCourseisOpen(s){
      let that = this;
      if (this.courseOfferingStatus) {
          let params = {
            courseId: s.courseId,
            isOpen: s.isOpen,
          };
          schoolCourseisOpen(params)
            .then((res) => {
              that.schoolCoursequerySchoolCourse();
              that.loading = false;
            })
            .catch(() => {
              that.loading = false;
            });
        }else{
           console.log('s:',s);
        }
      
    },
    //上一步或下一步
    handlePreOrNext(index,str){
      if (str=='saveCourse') {
        for (let index = 0; index < this.tableData.length; index++) {
          let item = this.tableData[index];
          item.gradeIdList = item.schoolCourseGradeList.map(it=>it.gradeId)
          if (item.gradeIdList.length==0) {
            return resetMessage({
              type:"info",
              message:`请为第${index+1}条课程最少选择一个年级!`
            })
          }
          if (!item.nodeId) {
            return resetMessage({
              type:"info",
              message:`请为第${index+1}条课程选择课程维度!`
            })
        }}
        let paramsArr = []
        if (this.courseOfferingStatus) {
          paramsArr = this.tableData
        }else{
          paramsArr = this.tableData.filter(item=>item.isOpen==1)
        }
        let params = {
          systemCourseList:paramsArr ,
        };
        console.log(this.tableData)
        //保存课程开设
        saveCourse(params).then(res=>{
          if (res.data.code=='0') {
            this.$emit('prevOrNext',index)
          }else{
              resetMessage({
                type:'error',
                message: res.data.msg,
              });
          }
        }).catch(err=>{
          console.log(err)
        })
      }else{
        this.$emit('prevOrNext',index)
      }
    },
    //跳转课程开设
    goClass(){
      let token = localStorage.getItem('token')
      let roleId = localStorage.getItem('roleId')
      let obj = this.myappList.find(item=>item.appId == 14)
      window.open(obj.appUrl + 'zpcourse?token=' + token +'&roleId=' + roleId) 
    },
    // 获取我的应用列表
    async getMyappList() {
      if (!this.roleId) {
        this.roleId = -1003
      }
      const { data: res } = await getMyappList({
        roleId: this.roleId,
      })
      console.log("应用列表",res.data)
      this.myappList = res.data
      
    },
    //多选框改变
    checkboxChange(val){
      console.log(val)
    }
  },
  async mounted() {
    // let info = JSON.parse(localStorage.getItem("schoolIds"));
    // this.schoolId = info;
    this.getMyappList()
    const { data: res } = await usercenterinfo()
    this.schoolId = res.data.schoolId
    this.schoolCoursequerySchoolCourse();
    this.subjectlist();
    this.gradegradelist();
    this.nodesgetListByLevel();
    this.schoolgetdepartmentlist();
    this.teacherlist();
    this.getConfigProgress()
  },
};
</script>

<style lang="less" scoped>
.add_calss{
  font-weight: bold;
  margin-right: 10px;
}
</style>


// WEBPACK FOOTER //
// src/views/bench/components/zpcourse.vue